import React from 'react';
import { useTranslation } from 'react-i18next';
import FeedCard from '../../../../shared/components/FeedCard';
import './styles.css';

const ProfilePosts = ({ posts }) => {
  const { t } = useTranslation('profile');

  if (!posts?.length) {
    return (
      <div className="empty-posts">
        <p>{t('posts.empty')}</p>
      </div>
    );
  }

  return (
    <div className="profile-posts">
      {posts.map(post => (
        <FeedCard 
          key={post.id} 
          post={post}
        />
      ))}
    </div>
  );
};

export default ProfilePosts; 